import { Injectable } from "@angular/core";
import { Doenca } from "@tivic-team/manager-ts/dist/grl";
import { CartaoDocumentoDoenca } from "@tivic-team/manager-ts/dist/mob/entities/cartao-documento-doenca.entity";
import { Cartao } from "@tivic-team/manager-ts/dist/mob/entities/cartao.entity";
import { GratuidadeSolicitacoesController } from "app/controllers/mob/gratuidade-solicitacoes.controller";
import { CartaoDocumentoDTO, CartaoDocumentoListDTO } from "app/model/dtos/mob/cartao-documento.dto";
import { PessoaFichaMedicaDTO } from "app/model/dtos/mob/pessoa-ficha-medica.dto";
import { LoaderService } from "../loader.service";
import { GratuidadeSolicitacoesSearch } from "./gratuidade-solicitacoes.search";


@Injectable({
    providedIn: "root",
})

export class GratuidadeSolicitacoesService{
    constructor(
        private _gratuidadeSolicitacoesController: GratuidadeSolicitacoesController,
        private _loaderService: LoaderService
    ){}

    async save(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO>{
        this._loaderService.show();
        if(cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento && cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento > 0){
            return this._gratuidadeSolicitacoesController.update(cartaoDocumentoDTO).finally(() => this._loaderService.hide());
        } else {
            return this._gratuidadeSolicitacoesController.create(cartaoDocumentoDTO).finally(() => this._loaderService.hide());
        }
    }

    async find(gratuidadeSolicitacoesSearch?: GratuidadeSolicitacoesSearch): Promise<Array<CartaoDocumentoListDTO>> {
        this._loaderService.show();
        try{
            return await this._gratuidadeSolicitacoesController.find((gratuidadeSolicitacoesSearch && gratuidadeSolicitacoesSearch.getFilters()) || null)
            .finally(() => this._loaderService.hide());
        } catch(error){
            this._loaderService.hide();
            return [];
        }
    }

    async getAll(): Promise<CartaoDocumentoListDTO[]>{
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.find().finally(() => this._loaderService.hide());

    }

    async get(cdCartaDocumento: number): Promise<CartaoDocumentoDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.get(cdCartaDocumento).finally(() => this._loaderService.hide());
    }

    async getDeficiencia(cdCartaoDocumento: number): Promise<Doenca[]> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getDeficiencia(cdCartaoDocumento).finally(() => this._loaderService.hide());
    }

    async getCartaoDocumentoDoenca(cdCartaoDocumento: number): Promise<CartaoDocumentoDoenca[]> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getCartaoDocumentoDoenca(cdCartaoDocumento).finally(() => this._loaderService.hide());
    }

    async getTramitacao(cdDocumento: number): Promise<CartaoDocumentoListDTO[]> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getTramitacao(cdDocumento).finally(() => this._loaderService.hide());
    }

    async getPessoaFichaMedicaByCPF(nrCpf: string): Promise<PessoaFichaMedicaDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getPessoaFichaMedicaByCPF(nrCpf).finally(() => this._loaderService.hide());
    }

    async getOcorrencias(cdCartaoDocumento: number): Promise<CartaoDocumentoListDTO[]> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getOcorrencias(cdCartaoDocumento).finally(() => this._loaderService.hide());
    }

    async getCartao(cdCartaoDocumento: number): Promise<Cartao> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getCartao(cdCartaoDocumento).finally(() => this._loaderService.hide());
    }

    async getPessoaByCartaoDocumento(cdCartaoDocumento: number): Promise<CartaoDocumentoDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getPessoasByCartaoDocumento(cdCartaoDocumento).finally(() => this._loaderService.hide());
    }

    async updateOcorrenciasDeferimento(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.updateOcorrenciasDeferimento(cartaoDocumentoDTO).finally(() => this._loaderService.hide());
    }

    async updateOcorrenciasIndeferimento(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.updateOcorrenciasIndeferimento(cartaoDocumentoDTO).finally(() => this._loaderService.hide());
    }

    async updateOcorrenciasAnulacao(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.updateOcorrenciasAnulacao(cartaoDocumentoDTO).finally(() => this._loaderService.hide());
    }

    async updateMarcarPericia(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO> {
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.updateMarcarPericia(cartaoDocumentoDTO).finally(() => this._loaderService.hide());
    }

    async getSolicitacaoProcedimentoReport(gratuidadeSolicitacoesSearch?: GratuidadeSolicitacoesSearch): Promise<Blob>{
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getSolicitacaoProcedimentoReport(gratuidadeSolicitacoesSearch && gratuidadeSolicitacoesSearch.getFilters())
        .finally(() => this._loaderService.hide())
    }

    async getSolicitacaoCartaoReport(gratuidadeSolicitacoesSearch?: GratuidadeSolicitacoesSearch): Promise<Blob>{
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getSolicitacaoCartaoReport(gratuidadeSolicitacoesSearch && gratuidadeSolicitacoesSearch.getFilters())
        .finally(() => this._loaderService.hide())
    }

    async getEmissaoCIReport(gratuidadeSolicitacoesSearch?: GratuidadeSolicitacoesSearch): Promise<Blob>{
        this._loaderService.show();
        return this._gratuidadeSolicitacoesController.getEmissaoCIReport(gratuidadeSolicitacoesSearch && gratuidadeSolicitacoesSearch.getFilters())
        .finally(() => this._loaderService.hide())
    }


}